import React from 'react';

import './index.css';
import Modal from '../Modal';
import { color } from 'echarts';

interface Props {
    title?: string,
    message?: string,
    visible: boolean,
    width?: string,
    onClick?: Function,
    onClose?: Function
}

const CustomPrompt: React.FC<Props> = (props) => {
    return (
        <div className='custom-prompt'>
            <Modal visible={props.visible} title={props.title} close={() => props.onClose && props.onClose()}>
                <div className="form">
                    <p> {props.message} </p>
                    <div className="commands">
                        <button
                            className="lc-button bg-info"
                            onClick={() => props.onClick && props.onClick()}
                        >
                        Sair
                        </button>
                        <button
                            type="reset"
                            className="lc-button bg-info"
                            onClick={() => props.onClose && props.onClose()}
                        >
                        Cancelar
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default CustomPrompt;
